import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

const FiltersBar = ({ filters, setFilters, filterOptions, availableSubfamilias }) => {
  const handleFilterChange = (key, value) => {
    const finalValue = value === "__all__" ? "" : value;
    if (key === "familia") {
      setFilters((prev) => ({ ...prev, [key]: finalValue, subfamilia: "" }));
    } else {
      setFilters((prev) => ({ ...prev, [key]: finalValue }));
    }
  };

  return (
    <Card className="p-4 border border-slate-200 shadow-sm sticky-header" data-testid="filters-bar">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {/* Estado Filter */}
        <div>
          <Label className="body-font text-xs text-slate-700 mb-1.5 block">Estado</Label>
          <Select data-testid="filter-estado" value={filters.estado} onValueChange={(v) => handleFilterChange("estado", v)}>
            <SelectTrigger className="body-font h-9 text-xs"><SelectValue placeholder="Todos" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todos</SelectItem>
              <SelectItem value="sin_stock">Sin Stock</SelectItem>
              <SelectItem value="stock_bajo">Stock Bajo</SelectItem>
              <SelectItem value="baja_rotacion">Baja Rotacion</SelectItem>
              <SelectItem value="normal">Normal</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {/* Familia Filter */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">Familia</Label>
          <Select data-testid="filter-familia" value={filters.familia} onValueChange={(v) => handleFilterChange("familia", v)}>
            <SelectTrigger className="body-font h-9 text-xs"><SelectValue placeholder="Todas" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todas</SelectItem>
              {filterOptions.familias.filter(Boolean).map((f) => <SelectItem key={f} value={f}>{f}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {/* Subfamilia Filter */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">SubFamilia</Label>
          <Select data-testid="filter-subfamilia" value={filters.subfamilia} onValueChange={(v) => handleFilterChange("subfamilia", v)} disabled={!filters.familia}>
            <SelectTrigger className="body-font h-9 text-xs"><SelectValue placeholder={filters.familia ? "Todas" : "Familia primero"} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todas</SelectItem>
              {availableSubfamilias.filter(Boolean).map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {/* Proveedor Filter */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">Proveedor</Label>
          <Select data-testid="filter-proveedor" value={filters.proveedor} onValueChange={(v) => handleFilterChange("proveedor", v)}>
            <SelectTrigger className="body-font h-9 text-xs"><SelectValue placeholder="Todos" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todos</SelectItem>
              {(filterOptions.proveedores || []).filter(Boolean).map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {/* Lote Desde */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">Lote Desde</Label>
          <Select data-testid="filter-lote-inicio" value={filters.loteInicio} onValueChange={(v) => handleFilterChange("loteInicio", v)}>
            <SelectTrigger className="body-font h-9 text-xs"><SelectValue placeholder="Todos" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todos</SelectItem>
              {filterOptions.lotes.filter(Boolean).map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {/* Lote Hasta */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">Lote Hasta</Label>
          <Select data-testid="filter-lote-final" value={filters.loteFinal} onValueChange={(v) => handleFilterChange("loteFinal", v)}>
            <SelectTrigger className="body-font h-9 text-xs"><SelectValue placeholder="Todos" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todos</SelectItem>
              {filterOptions.lotes.filter(Boolean).map((l) => <SelectItem key={l} value={l}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {/* Stock Min */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">Stock Min</Label>
          <Input data-testid="filter-stock-min" type="number" placeholder="0" value={filters.stockMin}
            onChange={(e) => handleFilterChange("stockMin", e.target.value)} className="body-font h-9 text-xs" />
        </div>

        {/* Stock Max */}
        <div>
          <Label className="body-font text-xs text-muted-foreground mb-1.5 block">Stock Max</Label>
          <Input data-testid="filter-stock-max" type="number" placeholder="999999" value={filters.stockMax}
            onChange={(e) => handleFilterChange("stockMax", e.target.value)} className="body-font h-9 text-xs" />
        </div>
      </div>
    </Card>
  );
};

export default FiltersBar;
